import { EVariationTypes } from 'core/common/constants/multivariation'
import { BULK_FIELD_NAME } from 'core/components/Multivariation/constants'
import { TVariationField } from 'core/components/Multivariation/types'
import { IStoreValues } from '../store'
import { getVariationByTypeAndValue } from '../utils'

export const getFirstVariationFields = (
  type: EVariationTypes,
  values: IStoreValues['variationValues']
): TVariationField[] => [
  {
    name: BULK_FIELD_NAME,
    variations: [],
    values: Object.keys(values).map(item => getVariationByTypeAndValue(type, item)),
  },
]
